import React from 'react';
import { APITypes } from '../../../../primary-record-types';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { LoadableAvatar, getFallbackFromName } from '../../../v2BaseComponents/Avatar';
import urls from '../../../../utils/urls';
import { useOrganizationId } from '../../../../hooks/api/useOrganization';
import { getIntl } from '../../../../utils/intl';
import getName from '../../../../utils/getName';
import { organizationRoles } from '../../../../utils/sharedMessages';
import LabelValueDisplay from '../../../v2BaseComponents/LabelValueDisplay';
import Text from '../../../v2BaseComponents/Text';

const intl = getIntl('OrganizationDetailsContent', {
    name: 'Name',
    email: 'Email',
    role: 'Role',
    isBillingAdmin: 'Is Billing Admin?',
    yes: 'Yes',
    no: 'No',
    groups: 'Groups',
});

export type DetailsContentOwnProps = {
    user: APITypes.organizationService.GetOrganizationUserResponse;
    userGroups: APITypes.organizationService.ListOrganizationUserOrganizationGroupsResponse['items'];
};

export type DetailsContentProps = DetailsContentOwnProps;

const DetailsContent: React.FC<DetailsContentProps> = (props) => {
    const organizationId = useOrganizationId();
    const fallbackName = getFallbackFromName(props.user.user.firstName, props.user.user.lastName);
    const name = getName(props.user.user);
    const role = organizationRoles(props.user.role);
    const isBillingAdmin = props.user.isBillingAdmin ? intl('yes') : intl('no');
    const groups = props.userGroups
        .map((group) => group.metadata.name)
        .sort((a, b) => a.localeCompare(b))
        .join(', ');
    return (
        <Stack vertical fullWidth justify="center" align="center" space={contentStackSpacing}>
            <Stack vertical fullWidth justify="center" align="center" space={1}>
                <LoadableAvatar
                    size="lg"
                    avatarUrl={urls.api.organizations.users.userAvatar(organizationId, props.user.organizationUserId)}
                    fallbackName={fallbackName}
                />
                <Text variant="h5">{name}</Text>
            </Stack>
            <LabelValueDisplay
                items={[
                    { label: intl('email'), value: props.user.user.email },
                    { label: intl('role'), value: role },
                    { label: intl('isBillingAdmin'), value: isBillingAdmin },
                    { label: intl('groups'), value: groups },
                ]}
                omitEmptyValues
            />
        </Stack>
    );
};

export default React.memo(DetailsContent);
